import { useEffect, useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../../shared/components/button/CreateButtonTrigger";
import CreateClientProductForm from "./CreateClientProductForm";
import { CLIENT_CATEGORIES_SELECTABLE } from "../../../../../../../shared/lib/apiEndpointsResolver";
import useAxios from "../../../../../../../hooks/useAxios";
import { catchFunction } from "../../../../../../../shared/lib/utils";

const CreateClientProductDialog = ({ id, onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const axios = useAxios();

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  useEffect(() => {
    axios
      .get(CLIENT_CATEGORIES_SELECTABLE(id))
      .then((response) => setCategories(response.data))
      .catch(catchFunction);
  }, [id]);

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="clients.detail.tabs.products.createForm.title"
      description="clients.detail.tabs.products.createForm.description"
      content={
        <CreateClientProductForm
          categories={categories}
          onSubmitHandler={onSubmit}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateClientProductDialog;
